export const catalogos = [
  {
    id: 1,
    nameImg: { pt: `Catálogo LUMIARQ`, en: `LUMIARQ Catalog`, es: `Catálogo LUMIARQ`,fr:`Catalogue LUMIARQ`, it:`Catalogo LUMIARQ`,de:`LUMIARQ-Katalog`, zh:`LUMIARQ 目录`},
    download: 'https://drive.google.com/file/d/1SPbjraT715EeaNnV0Xau5k6bfC3NajuR/view?usp=drive_link',
    linkImg: '/images/catalogos/cataLumiarq.png',
  },
    {
    id: 2,
    nameImg: {  pt: "Catálogo R-DESIGN", en: "R-DESIGN Catalog", es: "Catálogo R-DESIGN", fr: "Catalogue R-DESIGN", it: "Catalogo R-DESIGN",de:`R-DESIGN-Katalog`, zh: "R-DESIGN目录"},
    download: 'https://drive.google.com/file/d/1Jcsr-1ZI4alvQZc4sQO5ytO-065tOZQ9/view?usp=drive_link',
    linkImg: '/images/catalogos/r-design.png',
  },
  {
    id: 4,
    nameImg: { pt: "Catálogo LIVOLO",en: "LIVOLO Catalog",es: "Catálogo LIVOLO",fr: "Catalogue LIVOLO",it: "Catalogo LIVOLO",de:`LIVOLO-Katalog`,zh: "LIVOLO目录"},
    download: 'https://drive.google.com/file/d/10j_EE9fEIUrMd0tVafCPdSc0tfiMRiSx/view?usp=drive_link',
    linkImg: '/images/catalogos/Catalogo_LIVOLO.png',
  },
  {
    id: 5,
    nameImg: { pt: "Catálogo Suntree", en: "Suntree Catalog",es: "Catálogo Suntree",fr: "Catalogue Suntree", it: "Catalogo Suntree",de:`Suntree-Katalog`, zh: "Suntree目录"},
    download: 'https://drive.google.com/file/d/11WTS8PNBZPXXqAbdQvqNaHy-u_gbry3P/view?usp=drive_link',
    linkImg: '/images/catalogos/CatalogoSuntree.png',
  },
  {
    id: 6,
    nameImg: { pt: `Tabela de preços`, en: `Price list`, es: `Lista de precios`,fr:`Liste de prix`, it:`Listino prezzi`,de:`Preisliste`, zh:`价格表`},
    download: 'https://drive.google.com/file/d/1IZ2pExK3PVANsQmnHdfLfUdpI_OdvTEC/view?usp=drive_link',
    linkImg: '/images/catalogos/tabelageral2025_2.png',
  },
  {
    id: 3,
    nameImg: { pt: "Tabela de preços R-DESIGN",en: "R-DESIGN Price List", es: "Tabla de precios R-DESIGN",fr: "Tableau des prix R-DESIGN",de:`Preisliste R-DESIGN`,it: "Tabella prezzi R-DESIGN",  zh: "R-DESIGN价目表"},
    download: 'https://drive.google.com/file/d/1_7-Nen-qbt4emrd-uZYyF1YmURh9bbJd/view?usp=drive_link',
    linkImg: '/images/catalogos/TabelaPrecosRdesign.png',
  },
  ];